export default "__VITE_ASSET__e8c43676__"